export const userProfile = require("../assets/user-profile.png");
export const chatLogo = require("../assets/chatlogo.png");
export const connectLogo = require("../assets/connectlogo.png");
export const pitchLogo = require("../assets/pitchlogo.png");
export const profileLogo = require("../assets/profilelogo.png");
export const vbcLogo = require("../assets/vbclogo.png");
